import React from 'react'

import { Container, H1 } from '../index.js'

export default () => {
  return (
    <Container section>
      <H1>🙁 The resource you requested was not found</H1>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./client/src/components/errors/NotFound.js